var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDenied = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95694 4.54309L5.04309 8.45694",
    stroke: "#730A46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04309 4.54309L8.95694 8.45694",
    stroke: "#730A46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5C10.3137 12.5 13 9.81372 13 6.50002C13 3.18631 10.3137 0.500015 7 0.500015C3.68629 0.500015 1 3.18631 1 6.50002C1 9.81372 3.68629 12.5 7 12.5Z",
    stroke: "#730A46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDenied, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/denied.2ff097ea.svg";
export { ForwardRef as ReactComponent };